"use client";

import React from "react";
import { usePathname } from "next/navigation";

/**
 * The header menus are pure-CSS `group-hover` panels (no JS open state),
 * so after a menu link is clicked the panel stays visible on the new page
 * because the cursor is still hovering it. Remounting the menu subtree on
 * each route change gives the browser fresh DOM nodes that aren't in a
 * `:hover` state until the pointer moves again — so the panel closes the
 * moment navigation happens.
 *
 * `display: contents` keeps the wrapper layout-neutral (the wrapped
 * `<nav>` still drives flex layout as before).
 */
export function HoverNavReset({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  return (
    <div key={pathname} style={{ display: "contents" }}>
      {children}
    </div>
  );
}

export default HoverNavReset;
